export default "__VITE_ASSET__ZkSyXqcT__"